var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvironmentTopIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2749 8.33203C18.0163 8.63492 16.7172 8.81665 15.3778 8.85703V13.4407H19.9278C19.8874 11.5493 19.6518 9.83299 19.2749 8.33203Z",
    fill: "#c59d48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3712 2.32227V7.83477C16.6163 7.79438 17.8279 7.63284 18.9923 7.35015C18.1106 4.56361 16.7375 2.73284 15.3712 2.32227Z",
    fill: "#c59d48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.599 7.34321C11.7769 7.6259 12.9952 7.79417 14.2471 7.83455V2.30859C12.8807 2.70571 11.4875 4.53648 10.599 7.34321Z",
    fill: "#c59d48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1991 5.7479C21.6779 4.19982 19.7327 3.06905 17.5519 2.55078C18.5481 3.58059 19.3827 5.15559 19.9817 7.0806C21.1058 6.73733 22.1827 6.29309 23.1991 5.7479Z",
    fill: "#c59d48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9577 13.4409H26.5644C26.4433 10.8294 25.4673 8.43323 23.9058 6.53516C22.7548 7.16785 21.5365 7.68612 20.2644 8.06977C20.675 9.68516 20.9173 11.5092 20.9577 13.4409Z",
    fill: "#c59d48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66345 13.4416H14.2538V8.8579C12.901 8.81752 11.5885 8.63579 10.3231 8.32617C9.93941 9.82713 9.70384 11.5502 9.66345 13.4416Z",
    fill: "#c59d48"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9279 14.5586H15.3712V19.1355C16.7106 19.1759 18.0163 19.3509 19.275 19.6605C19.6519 18.1663 19.8875 16.4432 19.9279 14.5586Z",
    fill: "#c59d48"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3231 19.6672C11.5885 19.3576 12.901 19.1759 14.2538 19.1355V14.5586H9.66345C9.70384 16.4499 9.93941 18.173 10.3231 19.6672Z",
    fill: "#c59d48"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2538 25.6842V20.1582C13.0019 20.1986 11.7769 20.3669 10.599 20.6495C11.4875 23.4563 12.8807 25.2938 14.2538 25.6842Z",
    fill: "#c59d48"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5519 25.4486C19.7327 24.9236 21.6779 23.7996 23.2058 22.2448C22.1894 21.6996 21.1125 21.2554 19.9885 20.9121C19.3894 22.8438 18.5481 24.4121 17.5519 25.4486Z",
    fill: "#c59d48"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0326 2.56445C9.87206 3.08945 7.94033 4.2135 6.4259 5.75484C7.43552 6.29331 8.49898 6.73754 9.60956 7.07408C10.2086 5.15581 11.0432 3.59426 12.0326 2.56445Z",
    fill: "#c59d48"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2644 19.9297C21.5433 20.3134 22.7615 20.8317 23.9125 21.4644C25.474 19.5663 26.45 17.1701 26.5711 14.5586H20.9644C20.9173 16.4903 20.675 18.3076 20.2644 19.9297Z",
    fill: "#c59d48"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3712 20.1582V25.6774C16.7375 25.2669 18.1106 23.4361 18.9923 20.6428C17.8279 20.3601 16.6163 20.1986 15.3712 20.1582Z",
    fill: "#c59d48"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33361 8.06304C8.06823 7.67939 6.85669 7.16785 5.7192 6.53516C4.15766 8.43323 3.1817 10.8294 3.06055 13.4409H8.64035C8.674 11.5025 8.92304 9.67843 9.33361 8.06304Z",
    fill: "#c59d48"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63358 14.5586H3.05377C3.17493 17.1701 4.15089 19.5663 5.71243 21.4644C6.84993 20.8384 8.06146 20.3201 9.32685 19.9365C8.923 18.3211 8.67396 16.4971 8.63358 14.5586Z",
    fill: "#c59d48"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41925 22.2459C7.93367 23.7872 9.8654 24.9113 12.0327 25.4363C11.0433 24.4065 10.2087 22.8382 9.60963 20.9199C8.49906 21.2632 7.42887 21.7074 6.41925 22.2459Z",
    fill: "#c59d48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentTopIcn);
export default __webpack_public_path__ + "static/media/environment-top-icn.99c357610491a88f8e1c8617e7ead0e3.svg";
export { ForwardRef as ReactComponent };